import { render } from "./LoginPasswordForm.vue?vue&type=template&id=4a8e0aa7&ts=true"
import script from "./LoginPasswordForm.vue?vue&type=script&lang=ts"
export * from "./LoginPasswordForm.vue?vue&type=script&lang=ts"

import "./LoginPasswordForm.vue?vue&type=style&index=0&id=4a8e0aa7&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__